import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-m-3 p-text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "ขอบคุณสำหรับการสั่งซื้อ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mt-3" }, "สถานะปัจจุบันของคุณคือ", -1)
const _hoisted_4 = { class: "p-mt-1" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "p-d-flex" }
const _hoisted_7 = { class: "p-ml-2 p-my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, "หมายเลขการสั่งซื้อ: " + _toDisplayString(_ctx.transactionInvoice), 1),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          options: _ctx.statusList,
          optionLabel: "name",
          placeholder: "",
          class: "dropdown-status",
          style: _normalizeStyle({ 'background-color': _ctx.brandConfig.colorThemeMain })
        }, {
          value: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.statusName), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                style: _normalizeStyle(_ctx.getStatusStyle(slotProps.option.id))
              }, _toDisplayString(slotProps.index + 1), 5),
              _createElementVNode("div", _hoisted_7, _toDisplayString(slotProps.option.name), 1)
            ])
          ]),
          _: 1
        }, 8, ["options", "style"])
      ])
    ])
  ]))
}